import { DateTime } from 'luxon';
import { DateControlBase } from '../date-control-base';

const getWeekDateRangeLabel = (date: DateTime) => {
  const start = date.startOf('week');
  const end = date.endOf('week');

  if (start.monthLong === end.monthLong) {
    return `${start.day} - ${end.day} ${end.monthLong} ${end.toFormat('yyyy')}`;
  }
  return `${start.day} ${start.monthLong} - ${end.day} ${end.monthLong} ${end.toFormat('yyyy')}`;
};

type Props = {
  date: DateTime;
  onChange: (date: DateTime) => void;
  onToday: () => void;
};

export const WeekDateControl = ({ date, onChange, onToday }: Props) => {
  const label = getWeekDateRangeLabel(date);
  const weekNumber = date.toFormat('W');

  return (
    <DateControlBase
      label={label}
      centerLabel={`Week ${weekNumber}`}
      onPrev={() => onChange(date.minus({ weeks: 1 }).startOf('week'))}
      onNext={() => onChange(date.plus({ weeks: 1 }).startOf('week'))}
      onToday={onToday}
    />
  );
};
